module.exports = __webpack_public_path__ + "static/media/bestPresenter3.dd77d4c2.jpg";